import * as React from 'react';
import { MenuItem, TextField } from '@mui/material';

type Props = {
  id: any;
  field: string;
  api: any;
  value?: any;
  label?: string;
  items?: any[];
  type?: 'SIMPLE' | 'CODE' | 'COMBO' | string;
  valueKey?: string;
  autoOpen?: boolean;
};

const simpleLabel = (x: any) => x?.nam || x?.name || x?.recname || x?.label || x?.shc || x?.code || '';
const codeLabel = (x: any) => {
  const code = x?.shc || x?.code || x?.shortcode || '';
  const name = x?.nam || x?.name || x?.recname || '';
  return name ? `${code} - ${name}` : code;
};
const comboLabel = (x: any) => {
  const code = x?.shc || x?.code || x?.shortcode || '';
  const name = x?.nam || x?.name || x?.recname || '';
  return code && name ? `${name} (${code})` : (name || code);
};

export class FGridCodeCombo extends React.Component<Props, { open: boolean }> {
  state = { open: false };

  componentDidMount() {
    if (this.props.autoOpen) {
      setTimeout(() => this.setState({ open: true }), 0);
    }
  }

  onChange = async (event: any) => {
    const { id, field, api } = this.props;
    const value = event?.target?.value || '';

    await api.setEditCellValue({ id, field, value }, event);
    this.setState({ open: false });
  };

  render() {
    const {
      label,
      items = [],
      value = '',
      type = 'SIMPLE',
      valueKey = 'shc',
      autoOpen = false,
    } = this.props;

    const t = String(type || 'SIMPLE').toUpperCase();
    const labelFn = t === 'CODE' ? codeLabel : t === 'COMBO' ? comboLabel : simpleLabel;

    return (
      <TextField
        select
        size="small"
        label={label || ''}
        value={value || ''}
        onChange={this.onChange}
        fullWidth
        autoFocus
        SelectProps={autoOpen ? {
          open: this.state.open,
          onOpen: () => this.setState({ open: true }),
          onClose: () => this.setState({ open: false }),
        } : undefined}
      >
        <MenuItem value="">Select...</MenuItem>
        {items.map((x: any, idx: number) => {
          const optionValue = x?.[valueKey] || x?.shc || x?.code || x?.shortcode || x?.id || '';
          return (
            <MenuItem key={`${optionValue}-${idx}`} value={optionValue}>
              {labelFn(x)}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }
}

export default FGridCodeCombo;
